/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DeviceType, useDevice } from '@squiz/dxp-console-support';
import {
  ActionMenu,
  ActionMenuProps,
  BUTTON_FORMAT_SOFT,
  BUTTON_THEME_DEFAULT,
  ButtonList,
  ButtonListProps,
  DialogProps,
  ICON_DELETE,
  Toggle,
} from '@squiz/sds';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import { ICON_LOCK } from 'libs/sds/src/Icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FILE_EXPLORER_STRINGS } from '../../FileExplorer.constants';
import { useFileExplorerStore } from '../../FileExplorer.state';
import { DeleteItemDialogLauncher, deleteItemsWizardProps } from '../DeleteItemDialogLauncher/DeleteItemDialogLauncher';
import {
  PermissionsDialogLauncher,
  getPermissionsDialogProps,
} from '../PermissionsDialogLauncher/PermissionsDialogLauncher';
import { FileExplorerActionsProps } from './FileExplorerActions.props';

export const FileExplorerActions = ({ onFileIdToggle }: FileExplorerActionsProps): JSX.Element => {
  const { updateActiveDialog } = useDialogStore();
  const { selectedRows } = useFileExplorerStore();
  const { t } = useTranslation();
  const labels = {
    copy: t(FILE_EXPLORER_STRINGS.copy),
    delete: t(FILE_EXPLORER_STRINGS.delete),
    move: t(FILE_EXPLORER_STRINGS.move),
    permissions: t(FILE_EXPLORER_STRINGS.permissions),
    showId: t(FILE_EXPLORER_STRINGS.showFileId),
  };

  // TODO: OPTIMIZE-415
  // const moveButton = (
  //   <Button format={BUTTON_FORMAT_TRANSPARENT} icon={ICON_FOLDER} text={labels.move} theme={BUTTON_THEME_DEFAULT} />
  // );
  const deleteButton = <DeleteItemDialogLauncher />;

  // TODO: OPTIMIZE-483
  // const copyButton = (
  //   <Button format={BUTTON_FORMAT_TRANSPARENT} icon={ICON_FILE_COPY} text={labels.copy} theme={BUTTON_THEME_DEFAULT} />
  // );

  const toggleFileIds = (
    <div className="file-exporter__action-show-id">
      <Toggle callback={onFileIdToggle} fieldLabel={labels.showId} id="toggleShowId" key="showId" name="Show ID" />
    </div>
  );

  const permissionsButton = <PermissionsDialogLauncher />;
  const buttonListProps: ButtonListProps = {
    buttonKeys: ['permissions', 'delete', 'toggleId'],
    buttons: [permissionsButton, deleteButton, toggleFileIds],
    classes: 'file-explorer__action-list',
  };

  const permissionDialogProps: DialogProps = {
    ...getPermissionsDialogProps({}),
    stateHandler: useDialogStore,
  };

  // istanbul ignore next
  const actionMenuProps: ActionMenuProps = {
    buttonFormat: BUTTON_FORMAT_SOFT,
    buttonLabel: 'file-explorer-actions',
    buttonTheme: BUTTON_THEME_DEFAULT,
    classes: 'file-explorer__action-menu',
    itemList: [
      // TODO: OPTIMIZE-415
      // {
      //   action: (): void => {},
      //   icon: ICON_FOLDER,
      //   key: labels.move,
      //   label: labels.move,
      // },
      {
        action: (): void => {
          updateActiveDialog(deleteItemsWizardProps);
        },
        dataID: 'delete',
        icon: ICON_DELETE,
        isDisabled: selectedRows.length === 0,
        key: labels.delete,
        label: labels.delete,
      },
      // TODO: OPTIMIZE-483
      // {
      //   action: (): void => {},
      //   icon: ICON_FILE_COPY,
      //   key: labels.copy,
      //   label: labels.copy,
      // },
      {
        action: (): void => updateActiveDialog(permissionDialogProps),
        icon: ICON_LOCK,
        isDisabled: selectedRows.length === 0,
        key: labels.permissions,
        label: labels.permissions,
      },
    ],
    sectionKey: 'file-explorer-actions',
  };

  const device = useDevice();
  const isDesktop = device === DeviceType.desktop;

  if (isDesktop) {
    return <ButtonList {...buttonListProps} />;
  }
  return <ActionMenu {...actionMenuProps} />;
};
